import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import PopUpIcon from '../../../../commonComponents/formComponents/PopUpIcon';
import { useUpdateEffect } from '../../../../hooks';
import { useValidateNameAddressUsingEori } from '../../../hooks/AGS/useValidateNameAddressUsingEori';
import { isContactVisibleSelector } from '../../../selectors';
import { ActorContext } from './actorProvider';

export const Agent=({renderForm,isDMS,isImportShipment,actorType="agent"})=>{
      const dataSource=useSelector((state) => state.Actor.agent)
     const contactVisibilty=useSelector(isContactVisibleSelector)
     const actorDetails=useContext(ActorContext)
     const {disableFields}=useValidateNameAddressUsingEori(isImportShipment,isDMS,actorType)
     useUpdateEffect(()=>{
       if(!contactVisibilty && isDMS){
         actorDetails.clearContactDetails("agent") 
       }
     },[contactVisibilty])

     return renderForm ? renderForm({
      actorType,
      boxNumber:"14",
      disabled:false,
      actorName:"AGENT Name",
      displayContactInfo:isDMS && contactVisibilty,
      displayREP:true,
      dataSource:dataSource,
      disableFields,
      repvalidationMsg:isDMS && <PopUpIcon
        icon="info circle"
        popupText={<ul>
          <li>
          If Representation value is equal to 2 then set contact details from Agent. Contact details on Declarant level is not required.
          </li>
          <li>
          If Representation value is equal to 3 then set contact details from Declarant. Contact details on Agent level is not required.
          </li>
        </ul>}
      />
    

     }) : null
    
}